const selectors = {
    wrapper: '.js-vacancies-slider-parent',
    btn: '.js-vacancies-filter-btn',
    slider: '.js-vacancies-slider',
    slide: '.js-vacancies-slide'
};

const states = {
    isActive: 'is-active'
};

const ALL_CASES_ATTRIBUTE = 'all-vacancies';

const toggleActiveClass = ($elem, $this) => {
    $elem.find(`${selectors.btn}.${states.isActive}`).removeClass(states.isActive);
    $this.addClass(states.isActive);
};

const filteredVacancies = ($slider, dataAttr) => {
    $slider.slick('slickUnfilter');

    if (dataAttr === ALL_CASES_ATTRIBUTE) {
        $slider.slick('slickFilter', selectors.slide);
    } else {
        $slider.slick('slickFilter', $(`[data-vacancy-category="${dataAttr}"]`));
    }
};

const onBtnClick = ($slider) => (evt) => {
    const $this = $(evt.currentTarget);
    const dataAttr = $this.data('vacancy-filter');
    const $elem = $this.closest(selectors.wrapper);

    if ($this.hasClass(states.isActive)) {
        return;
    }

    toggleActiveClass($elem, $this);
    filteredVacancies($slider, dataAttr);
};

const vacanciesFiltering = () => {
    const $wrapper = $(selectors.wrapper);
    const $slider = $(selectors.slider);

    if (!$wrapper.length) {
        return;
    }

    $wrapper.on('click', `${selectors.btn}`, onBtnClick($slider));
};

export default vacanciesFiltering;
